import React, {memo, useContext} from 'react';
import he from "he";
import UserAvatar from './UserAvatar';
import LogoAvatar from './LogoAvatar';
import {
    getConversationAvatar,
    getConversationParticipants,
} from '../../services/helpers';
import {BROKER, VENDOR} from "../../services/constants/CompanyType";
import MessageActionDropdown from "../Messaging/MessageActionDropdown";
import {MESSAGE_USER_ADDED, MESSAGE_USER_FORWARDED, MESSAGE_USER_REMOVED} from "../../services/constants/MessageStatus";
import {AuthContext} from "../../context/AuthContext";
import {moment} from "../../services/moment-extensions";


const MessageItemNotification = ({item}) => {
    const authData = useContext(AuthContext);
    if (item?.latest_message.type === MESSAGE_USER_REMOVED)
        return (
            <span>
                            {
                                item?.latest_message.account.id === authData.id ? (
                                    <strong>You </strong>
                                ) : (
                                    <strong>{item?.latest_message.account.first_name} {item?.latest_message.account.last_name} </strong>
                                )
                            }

                removed <strong>{he.decode(item?.latest_message.content)}</strong> from the conversation.
                        </span>
        )


    if (item?.latest_message.type === MESSAGE_USER_ADDED)
        return (
            <span>
                            {
                                item?.latest_message.account.id === authData.id ? (
                                    <strong>You </strong>
                                ) : (
                                    <strong>{item?.latest_message.account.first_name} {item?.latest_message.account.last_name} </strong>
                                )
                            }

                added <strong>{he.decode(item?.latest_message.content)}</strong> to this conversation.
                        </span>
        )

}


const ConversationItem = memo(({
                                   conversation,
                                   authData,
                                   activeConversation,
                                   onSelectConversation,
                                   onHandleConversationArchived
                               }) => {
    const active = (activeConversation?.id === conversation.id);

    return (
        <div onClick={() => onSelectConversation(conversation, false)}
             rel={conversation.id}
             className={`${active ? 'sl-bg-primary-50i sl-border-solid sl-border-top-1 sl-border-bottom-1 sl-border-primary-200' : ''}
                     ${(conversation?.archived) ? 'sl-bg-gray-25 sl-text-gray-base' : 'sl-text-gray-700'}
                     sl-hover-gray-50 sl-cursor-pointer sl-border-bottom sl-border-right sl-flex sl-flex-col sl-gap-2 sl-py-10 sl-p-4 sl-mr-1 sl-conversations-list-container`}>
            {conversation.archived && (
                <div
                    className="sl-badge sl-badge-sm sl-text-xs sl-font-medium sl-badge-gray sl-mr-auto">Archived</div>
            )}
            <div
                className={`sl-flex sl-gap-3`}>
                <div className="sl-flex sl-flex-col sl-relative  sl-h-12 sl-w-12">
                    <UserAvatar userData={getConversationAvatar(conversation, authData)}
                                avatarClass={`sl-flex ${conversation.participants.length > 2 ? 'sl-h-10 sl-w-10' : 'sl-h-12 sl-w-12'}`}/>
                    {conversation.participants.length > 2 && <div
                        className="sl-max-w-6 sl-w-full sl-h-6 sl-badge sl-badge-border sl-badge-sm sl-badge-gray sl-absolute sl-right-0 sl-bottom-0 sl-ml-auto">
                        <div
                            className="sl-font sl-text-xs sl-font-medium sl-flex sl-align-center sl-justify-center">
                            +{conversation.participants.length - 2}
                        </div>
                    </div>}
                </div>
                <div className="sl-grow-1 sl-flex sl-flex-col sl-justify-flex-start relative">
                    <div
                        className="sl-flex sl-gap-2 sl-align-center sl-justify-space-between sl-ellipsis">
                        <div
                            className={`${conversation.unread ? 'sl-font-bold sl-text-gray-900' : 'sl-font-medium'}
                            ${!conversation.archived && 'sl-text-gray-900'} 
                             sl-font sl-text-md sl-ellipsis-one-line`}>
                            {getConversationParticipants(conversation, authData)}
                        </div>
                        <div
                            className={`${conversation.unread ? 'sl-text-primary-600 sl-text-md' : 'sl-text-gray-base sl-text-sm'} sl-font sl-font`}>
                            {moment(conversation.latest_message?.created_at * 1000).toDateWithToday()}
                        </div>
                    </div>

                    <div
                        className="sl-flex sl-align-center sl-gap-1 sl-justify-flex-start sl-ellipsis">
                        <LogoAvatar
                            avatarClass="sl-h-full sl-max-h-4 sl-w-4 sl-text-xs sl-line-h-3  sl-border-1 sl-border-solid sl-border-gray-200"
                            logo={conversation[authData.type === VENDOR ? BROKER : VENDOR][authData.type === BROKER ? 'favico' : 'logo']}
                            slug={conversation[authData.type === VENDOR ? BROKER : VENDOR]?.slug}
                        />
                        <div
                            className={`${!conversation.archived && 'sl-text-gray-700'}
                                 ${conversation.unread ? 'sl-font-semibold sl-text-gray-900' : 'sl-font-medium'} 
                                 sl-font sl-text-sm sl-ellipsis-one-line`}>
                            {conversation[authData.type === VENDOR ? BROKER : VENDOR]?.name}
                        </div>
                    </div>

                    <div
                        className={"sl-absolute sl-right-2 sl-top-9 sl-h-9 sl-w-9 sl-hide sl-conversation-list-actions"}>
                        <MessageActionDropdown
                            onSelectConversation={onSelectConversation}
                            conversationParticipants={conversation.participants}
                            activeConversation={conversation}
                            authData={authData}
                            onHandleConversationArchived={onHandleConversationArchived}

                        />
                    </div>
                </div>
            </div>
            <div className="sl-flex sl-flex-col sl-gap-0-point-5 sl-ellipsis">
                <div
                    className={`${conversation.unread ? 'sl-font-semibold' : 'sl-font-medium'}
                     ${!conversation.archived && 'sl-text-gray-700'} 
                     sl-font sl-text-start sl-text-sm sl-ellipsis-one-line`}>
                    {conversation.topic}
                </div>
                <div
                    className={`${conversation.unread ? 'sl-font-medium' : 'sl-font-normal'}
                     ${!conversation.archived && 'sl-text-gray-700'} 
                      sl-font sl-text-left sl-text-sm sl-text-xs sl-ellipsis-two-line`}>

                    {[MESSAGE_USER_ADDED, MESSAGE_USER_REMOVED, MESSAGE_USER_FORWARDED].includes(conversation?.latest_message.type) ?
                        <MessageItemNotification item={conversation} authData={authData}/> :
                        (conversation?.latest_message.content !== null ? (
                                <span
                                    dangerouslySetInnerHTML={{__html: conversation?.latest_message?.content}}
                                />
                            ) : (
                                <span>
                            {(conversation?.latest_message.content === null && conversation?.latest_message.files.length > 0) &&
                                ((conversation?.latest_message.account.id === authData.id) ? 'You' : conversation?.latest_message.account.first_name) +
                                ' sent ' +
                                ((conversation?.latest_message.files.length === 1) ? 'an attachment.' : conversation?.latest_message.files.length + ' attachments.')
                            }
                        </span>
                            )
                        )}
                </div>
            </div>
        </div>
    );
});

export default ConversationItem;
